const INTERSECTION_OBSERVER_OPTIONS = {
  root: null,
  rootMargin: '100%',
};
let intersectionObserverInstance: IntersectionObserver;
let intersectionCallbacks: IntersectionObserverCallback[] = [];
export const isSupportedIntersectionObserver = () =>
  typeof window !== 'undefined' && 'IntersectionObserver' in window;

export const createObserver = () => {
  if (!intersectionObserverInstance)
    intersectionObserverInstance = new IntersectionObserver(
      (entries, observer) =>
        intersectionCallbacks.forEach((callback) => callback(entries, observer)),
      INTERSECTION_OBSERVER_OPTIONS,
    );
  return intersectionObserverInstance;
};

export const observeElementOnScreen = (
  targetElement: Element,
  callback: IntersectionObserverCallback,
): void => {
  const handleIntersectionCallback: IntersectionObserverCallback = (entries, _observer) =>
    entries
      .filter((entry) => entry.target === targetElement && entry.isIntersecting)
      .forEach(() => callback(entries, _observer));
  intersectionCallbacks.push(handleIntersectionCallback);
  const instance = createObserver();
  instance.observe(targetElement);
};
export const unbindObserveElementOnScreen = (
  targetElement: Element,
  handleIntersectionCallback: IntersectionObserverCallback,
): void => {
  const instance = createObserver();
  instance.unobserve(targetElement);
  intersectionCallbacks = intersectionCallbacks.filter(
    (callback) => callback !== handleIntersectionCallback,
  );
};
